module.exports = __webpack_public_path__ + "img/img3.b0c9da93.svg";